import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class DeleteAuthorizedServicesVodafoneApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authorizedServicesVodafone/deleteVodafoneService',
      requesterInfo,
    })
  }

  public async deleteVodafoneService(id: number): Promise<void> {
    await this.postAsync<void>(id)
  }
}
